// GAVION lead statuses: Paramètres → Statuts des leads (admins).
export const leadStatusesFr = {
  title: "Statuts des compagnies",
  intro:
    "Les statuts des compagnies, dans l'ordre des menus et des filtres. Les 9 statuts de base ne peuvent pas être supprimés, mais peuvent être renommés, recolorés et déplacés. Un statut ajouté se comporte comme « En cours » : la compagnie reste dans la file d'appels. Un nom changé s'affiche tel quel en français et en anglais.",
  label: "Nom du statut",
  color: "Couleur",
  drag: "Glisser pour déplacer %{label}",
  move_up: "Monter %{label}",
  move_down: "Descendre %{label}",
  delete: "Supprimer %{label}",
  add: "Ajouter un statut",
  new_status: "Nouveau statut",
  save: "Enregistrer",
  saved: "Statuts enregistrés",
  loading: "Chargement des statuts…",
  deleted: "Statut supprimé",
  deleted_moved:
    "Statut supprimé : %{smart_count} compagnie déplacée |||| Statut supprimé : %{smart_count} compagnies déplacées",
  move_dialog: {
    title: "Supprimer le statut « %{label} »",
    body: "%{smart_count} compagnie a ce statut. La déplacer vers : |||| %{smart_count} compagnies ont ce statut. Les déplacer vers :",
    target: "Statut de destination",
    note: "Le déplacement ne déclenche aucune automatisation ni aucun webhook. Démo réservée, Client, Mauvais numéro, Ne pas appeler et En pause ne sont pas proposés : ils ont des effets ou des protections.",
    confirm: "Déplacer et supprimer",
    cancel: "Annuler",
  },
  errors: {
    forbidden:
      "Seul un administrateur peut modifier les statuts des compagnies.",
    invalid_lead_statuses:
      "La liste des statuts est invalide. Rechargez la page.",
    invalid_lead_status_value: "Valeur de statut invalide : %{detail}.",
    duplicate_lead_status: "Deux statuts ont la même valeur : %{detail}.",
    invalid_lead_status_label:
      "Chaque statut doit avoir un nom (60 caractères au plus).",
    invalid_lead_status_color: "Couleur invalide (format #rrggbb).",
    missing_system_lead_status: "Statuts de base manquants : %{detail}.",
    lead_status_in_use:
      "Des compagnies ont encore ces statuts : %{detail}. Supprimez-les un à un pour choisir où déplacer leurs compagnies.",
    lead_status_in_rules:
      "Ce statut est utilisé par des automatisations actives : %{detail}. Modifiez ou désactivez-les d'abord.",
    system_lead_status: "Ce statut ne peut pas être supprimé.",
    unknown_lead_status: "Ce statut n'existe plus. Rechargez la page.",
    invalid_move_target: "Choisissez un des statuts de destination proposés.",
    unknown: "L'enregistrement a échoué. Réessayez.",
    load_failed: "Impossible de lire les statuts. Rechargez la page.",
  },
};
